import {
  EDIT_INITIATIVE_REQUEST,
  EDIT_INITIATIVE_SUCCESS,
  EDIT_INITIATIVE_FAILED,
  GET_INITIATIVE_REQUEST,
  GET_INITIATIVE_SUCCESS,
  GET_INITIATIVE_FAILED,
  GET_PDF_PREVIEW_REQUEST,
  GET_PDF_PREVIEW_SUCCESS,
  GET_PDF_PREVIEW_FAILED,
} from './actionTypes';

const initialState = {
  initiativeData: null,
  loading: false,
  isPdfPreviewLoading: false,
  pdfPreviewLink: null,
  error: null,
};

const editInitiativeReducer = (state = initialState, {
  type, error, initiativeData, pdfPreviewLink,
}) => {
  switch (type) {
    case GET_INITIATIVE_REQUEST:
      return {
        ...state, loading: true, initiativeData: null, pdfPreviewLink: null,
      };
    case GET_INITIATIVE_SUCCESS:
      return {
        ...state,
        initiativeData: {
          ...initiativeData,
          organizations: initiativeData.organizations.map((org) => ({
            ...org,
            recruits_twilio_phone_number: org.recruits_twilio_phone_number?.id.toString() || '',
            users_twilio_phone_number: org.users_twilio_phone_number?.id.toString() || '',
          })),
        },
        pdfPreviewLink,
        loading: false,
      };
    case GET_INITIATIVE_FAILED:
      return { ...state, loading: false, error };
    case GET_PDF_PREVIEW_REQUEST:
      return { ...state, isPdfPreviewLoading: true };
    case GET_PDF_PREVIEW_SUCCESS:
      return {
        ...state,
        pdfPreviewLink,
        isPdfPreviewLoading: false,
      };
    case GET_PDF_PREVIEW_FAILED:
      return { ...state, isPdfPreviewLoading: false, error };
    case EDIT_INITIATIVE_REQUEST:
      return { ...state, loading: true };
    case EDIT_INITIATIVE_SUCCESS:
      return {
        ...state,
        initiativeData: null,
        loading: false,
      };
    case EDIT_INITIATIVE_FAILED:
      return { ...state, loading: false, error };
    default:
      return state;
  }
};

export default editInitiativeReducer;
